import React from 'react';
import { Tags } from 'components/BankCardSelect';
import { PlaidBankCardItem } from 'components/vendor/plaid/PlaidLink/types';
import classlist from 'utils/classlist';
import { getBankAccountType } from '../AchBank/helper';
import AchBankLogo from '../AchBankLogo';
import './style.scss';

interface AchBankItemProps {
    info: PlaidBankCardItem;
    withBorder?: boolean; // 带有边框
    showStatusTag?: boolean;
}

const AchBankItem: React.FC<AchBankItemProps> = ({ withBorder, info, showStatusTag }) => {
    return (
        <div
            className={classlist('ach-bank-item-info', {
                'bank-box': withBorder
            })}>
            <AchBankLogo className="bank-logo" {...info} />
            <div className="content">
                <div className="d-flex align-items-center mb-1">
                    <div className="bank-name">{info.institution_name?.toUpperCase()}</div>
                    <Tags.BankCardAuthStatusTag
                        status={info.bank_card_status!}
                        needAuthenticated={info.bank_card_need_auth}
                        hidden={!showStatusTag}
                    />
                </div>
                <div>{getBankAccountType(info)}</div>
            </div>
        </div>
    );
};

export default AchBankItem;
